import { useShowContext } from 'framework/show';
import { SxProps } from '@mui/material';
import { ControlsIssueSource, getControlIssues } from './controlIssues';
import ControlIssueIcons from './controlIssueIcons';

const HealthcheckSystemIssues = ({ sx }: { sx?: SxProps }) => {
  const { data } = useShowContext<ControlsIssueSource>();
  const projectData = data.getData();
  const controlIssues = getControlIssues(projectData);

  return <ControlIssueIcons issues={controlIssues} sx={sx} />;
};

export default HealthcheckSystemIssues;
